export enum PayrollStatus {
Draft,
Calculating,
Completed,
Cancelled,
Deleted,
}
